import { useRef, useState } from "react";
import type { ActionItem } from "./types";

interface ActiveSubmenu {
	item: ActionItem;
	anchor: HTMLElement;
}

const HOVER_DELAY_MS = 200;

export const useSubmenuHover = () => {
	const [activeSubmenu, setActiveSubmenu] = useState<ActiveSubmenu | null>(null);
	const hoverTimer = useRef<ReturnType<typeof setTimeout> | null>(null);

	const cancelHoverTimer = () => {
		if (hoverTimer.current) {
			clearTimeout(hoverTimer.current);
			hoverTimer.current = null;
		}
	};

	const openWithDelay = (item: ActionItem, anchor: HTMLElement) => {
		cancelHoverTimer();
		hoverTimer.current = setTimeout(() => {
			setActiveSubmenu({ item, anchor });
		}, HOVER_DELAY_MS);
	};

	const close = () => {
		cancelHoverTimer();
		setActiveSubmenu(null);
	};

	const getHandlers = (item: ActionItem) => ({
		onMouseEnter: (e: React.MouseEvent<HTMLElement>) => openWithDelay(item, e.currentTarget),
		onMouseLeave: cancelHoverTimer,
	});

	return { activeSubmenu, close, getHandlers };
};
